var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\nWELCOME PLACEHOLDER: This component should never be visible. see explanation in the route_is_welcome() function of MainView.vue\n")])}
var staticRenderFns = []

export { render, staticRenderFns }